<template>
	<div class="toolbar">
		<div class="search"><i class="fa-regular fa-magnifying-glass"></i><input type="text" :placeholder="placeholder" :value="value" @input="$emit('input', $event.target.value)" /></div>
		<div v-if="pills.length" class="status-quick">
			<span v-for="p in pills" :key="p.value" class="spill" :class="['s-' + (p.tone || 'grey'), { on: activePills.includes(p.value) }]" @click="$emit('pill', p.value)"><span class="dot"></span>{{ p.label }} <span v-if="p.count || p.count === 0" class="n">{{ p.count }}</span></span>
		</div>
		<div class="tb-actions">
			<button v-if="showFilters" class="pill" @click="$emit('filters')"><i class="fa-regular fa-sliders"></i> Filters<span v-if="filtersCount" class="badge">{{ filtersCount }}</span></button>
			<div v-if="showColumns" class="pop-wrap">
				<button class="pill" :class="{ on: colMenu }" @click="colMenu = !colMenu"><i class="fa-regular fa-table-columns"></i> Columns <span class="badge grey">{{ enabledCount }}</span></button>
				<div v-if="colMenu" class="pop-back" @click="colMenu = false"></div>
				<div v-if="colMenu" class="pop pop-cols">
					<input class="pop-search" placeholder="Search columns…" v-model="colSearch" />
					<div class="pop-scroll">
						<template v-for="g in columnGroups">
							<div :key="'g:' + g.name" class="pop-group">{{ g.name }}</div>
							<label v-for="col in g.items" :key="col.key" class="pop-row"><input type="checkbox" :checked="!!cols[col.key]" @change="toggleCol(col.key)" /> {{ col.label }}</label>
						</template>
					</div>
				</div>
			</div>
			<slot name="actions"></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PeToolbar',
	props: {
		value: { type: String, default: '' },
		placeholder: { type: String, default: 'Search' },
		pills: { type: Array, default: () => [] },
		activePills: { type: Array, default: () => [] },
		filtersCount: { type: Number, default: 0 },
		columns: { type: Array, default: () => [] },
		cols: { type: Object, default: () => ({}) },
		showFilters: { type: Boolean, default: true },
		showColumns: { type: Boolean, default: true },
	},
	data() {
		return { colMenu: false, colSearch: '' }
	},
	computed: {
		enabledCount() { return this.columns.filter(c => this.cols[c.key]).length },
		columnGroups() {
			const q = this.colSearch.toLowerCase().trim()
			const groups = {}
			this.columns.forEach(col => { if (q && !col.label.toLowerCase().includes(q)) return; const g = col.group || 'Columns'; (groups[g] = groups[g] || []).push(col) })
			return Object.keys(groups).map(name => ({ name, items: groups[name] }))
		},
	},
	methods: {
		// cols is owned by the view: emit a copy, never mutate the prop
		toggleCol(key) { const c = Object.assign({}, this.cols); c[key] = !c[key]; this.$emit('update:cols', c) },
	},
}
</script>
